import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import "./index.css";

// Lazy-loaded pages
const Home        = lazy(() => import("./pages/Home"));
const Tjanster    = lazy(() => import("./pages/Tjanster"));
const OmOss       = lazy(() => import("./pages/OmOss"));
const Kontakt     = lazy(() => import("./pages/Kontakt"));

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => window.scrollTo({ top: 0, behavior: "smooth" }), [pathname]);
  return null;
};

// Loader
const Loader = () => (
  <div className="flex justify-center items-center py-20">
    <div className="h-10 w-10 border-4 border-blue-600 border-t-transparent animate-spin rounded-full" />
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Suspense fallback={<Loader />}>
        <main className="min-h-screen pt-4">
          <Routes>
            <Route path="/"         element={<Home />} />
            <Route path="/tjanster" element={<Tjanster />} />
            <Route path="/om-oss"   element={<OmOss />} />
            <Route path="/kontakt"  element={<Kontakt />} />
            {/* fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </Suspense>
      <Footer />
    </Router>
  );
}

export default App;
